import request from "@/utils/request";

const getUserInfo = {
    
    get: (data) => {
        return request({
            url: '/users/getUserInfo',
            method: 'GET',
            data
        })
    },
    editUserInfo: (data) => {
        return request({
            url: '/users/editUserInfo',
            method: 'POST',
            data
        })
    },
    upload: (data) => {
        return request({
            url: '/common/upload',
            method: 'POST',
            data
        })
    },
    
}
export default getUserInfo;